import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Orders } from '../components/Orders';
import { useTranslation } from '../i18n';

export const OrdersPage: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [paymentMessage, setPaymentMessage] = useState('');

  useEffect(() => {
    if (searchParams.get('payment') === 'success') {
      setPaymentMessage(t('payment.success'));
      navigate('/orders', { replace: true });
    }
  }, [searchParams, navigate, t]);

  return (
    <>
      {paymentMessage && (
        <div className="alert alert-success">
          {paymentMessage}
          <button className="dismiss" onClick={() => setPaymentMessage('')}>&times;</button>
        </div>
      )}
      <Orders />
    </>
  );
};
